import useResize from './useResize';
import { headerHeight, headerResponsiveHeight } from 'src/shared/theme/var.module.scss';

export default function useScrolling() {
    const { isTablet, isMobile } = useResize();
    const scrollToView = (ref: React.MutableRefObject<any>) => {
        const height = parseInt((isTablet || isMobile ? headerResponsiveHeight : headerHeight).replace('px', ''), 10);
        window.scrollTo({ top: ref.current?.offsetTop - height, behavior: 'smooth' });
    };

    return { scrollToView };
}
